import { Brand } from "types/common";

const START_SLASH_REGEX = /^\//;

export const getPLPContentPageKey = (brand: Brand | "shared", path: string) =>
  `plp_${brand}_${path.replace(START_SLASH_REGEX, "")}`;
export const getTabsKey = (brand: Brand | "shared", path: string) =>
  `tabs_${brand}_${path.replace(START_SLASH_REGEX, "")}`;
